import { IAction } from './action';

export class ClearError implements IAction {

}
